import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin } from "lucide-react";

const Footer = () => {
    return (
        <footer data-testid="site-footer" className="bg-[#0F2A8C] text-white">
            <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4">
                <div className="space-y-5">
                    <img src="/assets/logo-white.webp" alt="Eradikbreizh" className="h-auto w-60 sm:w-64" />
                    <p className="text-sm leading-relaxed text-white/80">
                        Société spécialisée dans l'élimination des punaises de lit et des cafards.
                        Entreprise agréée CertiBIOCIDE. Sans majoration en semaine, samedis, dimanches et jours fériés : +20 %.
                    </p>
                </div>

                <div>
                    <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white/80">Navigation</h3>
                    <ul className="mt-5 space-y-3 text-sm">
                        <li><Link data-testid="footer-link-accueil" to="/" className="text-white/85 transition-colors hover:text-white">Accueil</Link></li>
                        <li><Link data-testid="footer-link-punaises" to="/punaises-de-lit" className="text-white/85 transition-colors hover:text-white">Punaises de lit</Link></li>
                        <li><Link data-testid="footer-link-cafards" to="/cafards" className="text-white/85 transition-colors hover:text-white">Cafards</Link></li>
                        <li><Link data-testid="footer-link-tarifs" to="/tarifs" className="text-white/85 transition-colors hover:text-white">Tarifs 2026</Link></li>
                        <li><Link data-testid="footer-link-protocole" to="/protocole-punaises" className="text-white/85 transition-colors hover:text-white">Protocole punaises de lit</Link></li>
                        <li><Link data-testid="footer-link-protocole-cafards" to="/protocole-cafards" className="text-white/85 transition-colors hover:text-white">Protocole cafards</Link></li>
                        <li><Link data-testid="footer-link-zone" to="/zone-intervention" className="text-white/85 transition-colors hover:text-white">Zone d'intervention</Link></li>
                        <li><Link data-testid="footer-link-contact" to="/contact" className="text-white/85 transition-colors hover:text-white">Contact & devis</Link></li>
                        <li><Link data-testid="footer-link-pros" to="/pros" className="text-white/85 transition-colors hover:text-white">Espace pros</Link></li>
                        <li><Link data-testid="footer-link-hotels" to="/hotels" className="text-white/85 transition-colors hover:text-white">Hôtels &amp; hébergements</Link></li>
                    </ul>
                </div>

                <div>
                    <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white/80">Contact</h3>
                    <ul className="mt-5 space-y-3 text-sm text-white/85">
                        <li className="flex items-center gap-3">
                            <Phone className="h-4 w-4 text-white" />
                            <a data-testid="footer-phone-link" href="tel:+33255992243" className="transition-colors hover:text-white">02 55 99 22 43</a>
                        </li>
                        <li className="flex items-center gap-3">
                            <Mail className="h-4 w-4 text-white" />
                            <a data-testid="footer-email-link" href="mailto:contact@eradikbreizh.fr" className="transition-colors hover:text-white">contact@eradikbreizh.fr</a>
                        </li>
                        <li className="flex items-center gap-3">
                            <Clock className="h-4 w-4 text-white" />
                            Lundi - Dimanche, 9h00 à 20h00
                        </li>
                        <li className="flex items-center gap-3">
                            <MapPin className="h-4 w-4 text-white" />
                            Basé au Mont-Dol (35) · Saint-Malo & rayon de 80 km
                        </li>
                    </ul>
                </div>

                <div>
                    <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white/80">Urgence 7j/7</h3>
                    <p className="mt-5 text-sm leading-relaxed text-white/80">
                        Intervention possible sous 2h, du lundi au dimanche de 9h à 20h.
                    </p>
                    <a
                        data-testid="footer-devis-button"
                        href="tel:+33255992243"
                        className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold text-brand transition-[background-color,transform] duration-300 hover:bg-slate-100 hover:scale-105 active:scale-95"
                    >
                        <Phone className="h-4 w-4" />
                        Appeler maintenant
                    </a>
                </div>
            </div>

            <div className="border-t border-white/20 px-5 py-6 sm:px-8">
                <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 text-xs text-white/70 sm:flex-row sm:items-center">
                    <p>© {new Date().getFullYear()} Eradikbreizh. Tous droits réservés.</p>
                    <div className="flex gap-5">
                        <Link data-testid="footer-link-mentions" to="/mentions-legales" className="transition-colors hover:text-white">Mentions légales</Link>
                        <Link data-testid="footer-link-confidentialite" to="/politique-confidentialite" className="transition-colors hover:text-white">Politique de confidentialité</Link>
                        <Link data-testid="footer-link-cgv" to="/cgv" className="transition-colors hover:text-white">CGV</Link>
                    </div>
                    <div className="flex flex-col items-start gap-1.5 sm:items-end">
                        <p>Vous pouvez vous inscrire gratuitement sur la liste d'opposition au démarchage téléphonique BLOCTEL.</p>
                        <Link data-testid="footer-link-admin" to="/admin" className="text-white/40 transition-colors hover:text-white">Admin</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
